import { render, staticRenderFns } from "./form12a.vue?vue&type=template&id=f8439f7e&scoped=true&"
import script from "./form12a.vue?vue&type=script&lang=js&"
export * from "./form12a.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8439f7e",
  null
  
)

export default component.exports